import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import {
  clearBranchForm,
  onChangeBranchForm,
  toggleBranchModal,
} from "../../redux/branchSlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";
import {
  CREATE_BRANCH,
  UPDATE_BRANCH,
} from "../../../../graphql/mutations/branch";
import { GET_BRANCH_LIST } from "../../../../graphql/queries/branch";

const BranchForm = () => {
  const dispatch = useDispatch();
  const { branchForm } = useSelector((state) => state.branch);

  const [createBranch, { loading }] = useMutation(CREATE_BRANCH, {
    refetchQueries: [{ query: GET_BRANCH_LIST }],
    onCompleted: (data) => {
      if (data.createBranch) {
        dispatch(toggleBranchModal());
        showSuccessToast();
        dispatch(clearBranchForm());
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [updateBranch, { loading: updateLoading }] = useMutation(
    UPDATE_BRANCH,
    {
      refetchQueries: [{ query: GET_BRANCH_LIST }],
      onCompleted: ({ updateBranch }) => {
        if (updateBranch) {
          dispatch(toggleBranchModal());
          showSuccessToast();
          dispatch(clearBranchForm());
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    branchForm?.id
      ? updateBranch({
          variables: {
            id: branchForm.id,
            name: branchForm.name,
            branchLink: branchForm.branchLink,
          },
        })
      : createBranch({
          variables: {
            name: branchForm.name,
            branchLink: branchForm.branchLink,
          },
        });
  };

  const handleChange = (e) => {
    dispatch(
      onChangeBranchForm({
        ...branchForm,
        [e.target.name]:
          e.target.type === "number"
            ? parseInt(e.target.value)
            : e.target.value,
      })
    );
  };

  const isLoading = updateLoading || loading;

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່ຈຸ"
        name="name"
        onChange={handleChange}
        type="text"
        value={branchForm.name}
        errorParam="name"
        required={true}
      />
      <CustomFormGroup
        label="ລິງຈຸ"
        name="branchLink"
        onChange={handleChange}
        type="text"
        value={branchForm.branchLink}
      />
      <div className="text-center">
        <SubmitButton loading={isLoading} />
      </div>
    </Form>
  );
};

export default BranchForm;
